import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import ProjectCardComponent from './ProjectCardComponent'
import { createSelector } from '@reduxjs/toolkit'
import { Grid } from '@mui/material'
import { useEffect, useRef } from 'react'
import { updateSelectedProject } from '../../actions/organization'

interface ProjectsListProps {
  clientId?: string
}

const projectsSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.projects,
)
const selectedProjectSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.selectedProject,
)
const searchFilterSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.searchFilter,
)

const ArchitectProjectsListComponent: React.FC<ProjectsListProps> = ({
  clientId,
}) => {
  const dispatch = useDispatch()
  const projects = useSelector(projectsSelector)
  const selectedProject = useSelector(selectedProjectSelector)
  const filteredProjects = clientId
    ? projects.filter((project) => project.client_id === clientId)
    : projects
  const searchFilter = useSelector(searchFilterSelector)
  const projectRefs = useRef<{ [key: string]: HTMLDivElement | null }>({})

  useEffect(() => {
    if (searchFilter) {
      const matchingProject = filteredProjects.find(
        (project) => project.name === searchFilter,
      )
      if (matchingProject) {
        dispatch(updateSelectedProject(matchingProject))
        const ref = projectRefs.current[matchingProject.id]
        if (ref) {
          ref.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }
    }
  }, [searchFilter])

  return (
    <Grid
      container
      spacing={'1rem'}
      sx={{
        overflowY: 'auto',
        boxSizing: 'border-box',
        pb: '1rem',
      }}
    >
      {filteredProjects.map((project, index) => (
        <Grid
          key={index}
          size={4}
          ref={(el) => (projectRefs.current[project.id] = el)}
          sx={{
            border:
              selectedProject?.id === project.id
                ? '2px solid #1705E5'
                : '2px solid transparent',
            borderRadius: '0.4rem',
            '&:hover': {
              border: '2px solid #1705E5',
            },
          }}
        >
          <ProjectCardComponent project={project} />
        </Grid>
      ))}
    </Grid>
  )
}

export default ArchitectProjectsListComponent
